<script>
// import axios from 'axios';
// import router from '@/router';
/*import logoutButton from './logout-button';*/
import Header from '@/components/front/Header';
import Footer from '@/components/front/Footer';
// import { us_states } from '@/state/helpers';
// import { required, email, numeric } from 'vuelidate/lib/validators';

export default {
  page: {
    title: 'Volunteer System',
    meta: [
      {
        name: 'Volunteer System',
      },
    ],
  },
  components: { /*logoutButton ,*/ Header, Footer },
  data() {
    return {
      title: '',
      items: [
        {
          text: '',
          href: '/',
        },
      ],

      age:null,
      ageError:false,
      states: [],
      addContactInfoForm: {
        first_name: '',
        middle_name: '',
        last_name: '',
        DOB: '',
        gender: '',
        address: '',
        address2: '',
        city: '',
        state: '',
        zip_code: '',
        email: '',
        mobile: '',
        phone: '',
      },
      typeSubmit: false,
    };
  },

  mounted() {
  },
  methods: {
   
  },
};
</script>
<template>
  <div>
    <Header></Header>
    <div class="main-body">
      <div id="main-title" class="secondary">
        <div class="container">
          <div class="row">
            <div class="col-12 col-lg-6 align-self-center">
              <h3 class="title">
                Contact Us
              </h3>
            </div>
          </div>
        </div>
      </div>
      <div id="contact_us" class="p-5">
        <div class="container">
        
            <form action="">
                
            </form>


        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>
